module.exports = __webpack_public_path__ + "assets/images/snapp-login-background.png";